module.exports = __webpack_public_path__ + "static/img/bg01.cb17fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg01.png
// module id = jBbT
// module chunks = 62